// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const clauncher: PokeData = {
  "id": 692,
  "name": "clauncher",
  "height": 5,
  "weight": 83,
  "base_experience": 66,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "vice-grip",
    "swords-dance",
    "water-gun",
    "bubble-beam",
    "bubble",
    "splash",
    "crabhammer",
    "flail",
    "muddy-water",
    "bounce",
    "water-sport",
    "water-pulse",
    "aura-sphere",
    "aqua-jet",
    "hone-claws",
    "smack-down"
  ],
  "moves": [
    "bubble-beam",
    "bubble",
    "splash",
    "aqua-jet",
    "water-spout",
    "hydro-pump",
    "whirlpool",
    "rain-dance",
    "brine",
    "liquidation",
    "aqua-cutter",
    "aqua-tail",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 355,
    "item": null,
    "species": [
      {
        "name": "clauncher",
        "order": 693,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "clawitzer",
        "order": 694,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 692,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56.25,
    "speed": 44,
    "ability_power": 58
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
